import {ChangeDetectionStrategy, ChangeDetectorRef, Component,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FormFieldConfig} from "../../../../model/api/form-field-config";
import {ClearingFlexService} from "../../../../services/clearing/flex/clearing-flex.service";
import {FlexTradesRequest} from "../../../../model/clearing/flex/flex-trades-request";
import {CommonFieldService} from "../../../../services/common/common-field.service";
import {AppConfigService} from "../../../../services/app-config.service";
import {ClearingTradeInfoService} from "../../../../services/clearing/clearing-trade-info.service";
import {FlexFormDialogBaseComponent} from "../flex-form-dialog-base.component";
import {FieldsService} from "../../../../services/common/fields-service";
import {
  ClearingFlexOrderDataLoadingService
} from "../../../../services/clearing/flex/clearing-flex-order-data-loading.service";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-flex-add-orders-form-dialog',
  templateUrl: './flex-add-orders-form-dialog.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlexAddOrdersFormDialogComponent extends FlexFormDialogBaseComponent {

  formRecord: FlexTradesRequest = undefined;

  constructor(cdref: ChangeDetectorRef,
              clearingFlexService: ClearingFlexService,
              messageService: MessageService,
              configService: AppConfigService,
              clearingTradeInfoService: ClearingTradeInfoService,
              commonFieldService: CommonFieldService,
              translateService: TranslateService,
              fieldsService: FieldsService,
              private dataLoadingService: ClearingFlexOrderDataLoadingService) {
    super(cdref,
      clearingFlexService,
      messageService,
      configService,
      clearingTradeInfoService,
      commonFieldService,
      translateService,
      fieldsService);
  }

  protected initConfigs() {
    super.initConfigs();
    this.dataLoadingService.loadData(this.tracker);

    this.dialogFormTitle = this.getTranslation('page.' + this.transPartKey + '.dialog-order-title');


    this.formConfig = [
      {
        group: 'upload',
        fields: [
          {
            field: 'mapping',
            column: 3,
            type: TYPE.DROPDOWN,
            options: record => this.dataLoadingService.orderFlexTemplates,
            required: true,
            hidden: record => this.dataLoadingService.orderFlexTemplates.length<2
          },
          {
            column: 9,
            type: TYPE.NONE,
            hidden: record => this.dataLoadingService.orderFlexTemplates.length<2
          },
          {
            field: 'file',
            column: 12,
            type: TYPE.FILEUPLOAD,
            accept: '.csv,.xml,.json',
            validate: (rec: any) => this.validateUploadFile(),
            required: true
          }],
      },
    ];

  }

  private validateUploadFile() {
    return this.formRecord && (this.formRecord.file) ? '' : 'No file selected';
  }

  save() {
    this.formLoading = true;
    this.markForCheck();
    const reader = new FileReader();
    reader.readAsDataURL(this.formRecord.file);
    reader.onload = () => {
      const base64String = (reader.result as string).split(',')[1];
      this.formRecord.fileName = this.formRecord.file.name;
      this.formRecord.base64FileContent = base64String;
      this.ccFormDialog.reloadFieldValueMap();
      this.clearingFlexService.ordersRequest(this.formRecord).subscribe(validation => {
        if (validation.success) {
          this.closeDialog();
          this.infoMessage(validation.message)
        } else {
          this.ccFormDialog.ccForm.errorMessage(validation.message);
        }
        setTimeout(() => this.formLoading = false);
      });
    };

  }

  showDialog(): void {
    if (this.ccFormDialog)
      this.ccFormDialog.reloadFieldValueMap();
    this.formRecord = new FlexTradesRequest();
    if (this.dataLoadingService.orderFlexTemplates.length > 0) {
      this.formRecord.mapping = this.dataLoadingService.orderFlexTemplates[0].id;
    }
    this.dialogFormVisible = true;
    this.dialogFormVisibleChange.emit(true);
    this.markForCheck();
  }

}
